<template>
  <div id="aprok-faq-area" class="aprok-faq-area">
    <div class="container">
      <div class="row">
        <div class="col-xl-8 col-lg-8 mx-auto">
          <div class="section-title text-center mb-80">
            <h2>常见问题</h2>
            <p>更有趣的年轻人社交APP，让你快速找到对的人。</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-12 wow fadeInLeft">
          <div class="faq-img">
            <img
              class="faq-app-icon"
              src="@/assets/picture/sicunxindong-icon.png"
              alt="私存心动图标"
            />
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-12 wow fadeInRight">
          <div class="aprok-accordion-wrapper">
            <div class="accordion">
              <!-- 卡片1 -->
              <div
                class="card"
                v-for="(item, index) in areaData"
                :key="item.name"
              >
                <div class="card-header">
                  <h2 class="mb-0">
                    <a
                      :class="
                        index == activeIndex
                          ? 'btn btn-link'
                          : 'btn btn-link collapsed'
                      "
                      @click="tabClick(index)"
                    >
                      {{ item.title }}
                    </a>
                  </h2>
                </div>
                <div
                  :class="
                    index == activeIndex
                      ? 'card-box show'
                      : 'card-box'
                  "
                >
                  <div class="card-body">
                    <p>
                      {{ item.content }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FaqArea",
  data() {
    return {
      areaData: [
        {
          name: "card1",
          title: "怎么加入私存心动?",
          content:
            "通过各大应用(华为、小米、OPPO)市场搜索私存心动、或者在我们官方首页链接下载",
        },
        {
          name: "card2",
          title: "在私存心动能够干什么呢?",
          content:
            "可以在首页创建自己的语音派对或者加入其他人的派对，然后跟里面小姐姐小哥哥们语音聊天，也可以私信聊天，赠送礼物等",
        },
        {
          name: "card3",
          title: "在私存心动怎么获取礼物呢？",
          content: "可以在是在派对中密友赠送，或者通过派对中的小游戏获得",
        },
        {
          name: "card4",
          title: " 7天/24小时 支持",
          content: "在软件使用的任何问题都可以通过客服入口联系到并反馈给我们",
        },
      ],
      activeIndex: 0,
    };
  },
  methods: {
    tabClick(i) {
      this.activeIndex = i;
    },
  },
};
</script>

<style lang="less" scoped>
.faq-app-icon {
  display: block;
  width: min(100%, 360px);
  margin: 0 auto;
  border-radius: 24px;
}

.card-box{
  max-height: 0;
  transition: all 0.3s ease-out;
}
.show{
  max-height: 120px;
}
</style>
